/**
 * Cobertura mínima requerida, expresada como fracción sobre la cantidad de la orden.
 * La suma de las bolsas debe ESTRICTAMENTE superar este valor — es decir, cubrir
 * la cantidad de la orden con un margen mayor al 10% (según spec ODD).
 */
export const SILO_BAG_COVERAGE_MARGIN = 1.10;
